
export class OrderHelper {
    static order(orders: any, field: string) {
        for (let f in orders ) {
            if (field === f) {
                if (orders[f] === '+') {
                    orders[f] = '-';
                } else {
                    orders[f] = '+';
                }
            } else {
              if(orders[f]) {
                orders[f] = '+-'; // Aquellas columnas por las que no se tienen que ordenar se mantienen en null mientras que las otras le ponemos +- para que no se ordene sobre esa columna, pero que sigamos teniendo opcion de ordenar por esta
              }
            }
        }
        return orders;
    }
}
